import { useEffect } from 'react';
import cn from 'classnames';
import {
  IconClose,
  IconError,
  IconInfo,
  IconSuccess,
  IconWarning,
} from '~/icons';

import css from './Toast.module.css';

const iconMap = {
  success: <IconSuccess />,
  error: <IconError />,
  warning: <IconWarning />,
  info: <IconInfo />,
};

interface ToastProps {
  id: string;
  title?: string;
  description: string;
  type: 'error' | 'success' | 'info' | 'warning';
  autoClose?: number | false;
  onClose: () => void;
}

export function Toast({
  title,
  description,
  type,
  autoClose,
  onClose,
}: ToastProps) {
  useEffect(() => {
    if (autoClose === false || typeof autoClose !== 'number') return;
    const timer = setTimeout(onClose, autoClose);
    return () => clearTimeout(timer);
  }, [autoClose, onClose]);

  return (
    <div className={cn(css.toast, css[`toast--${type}`])}>
      <div className={css.toastIcon}>{iconMap[type]}</div>
      <div className={css.toastBody}>
        {title && <span className={css.toastTitle}>{title}</span>}
        <p className={css.toastDescription}>{description}</p>
      </div>
      <button className={css.closeButton} onClick={onClose} aria-label="Close">
        <IconClose />
      </button>
    </div>
  );
}
